export default __webpack_public_path__ + "static/media/0303-1-1347x663-800x394.96766129.jpg";